<template>
  <div class='root' >
    <el-container>
      <el-header height="" style="padding:0px">
        <!-- <div target=“_blank” @click="headerImgClick" :style="{backgroundImage:'url(' + defaultHeaderImg + ')','padding-bottom': '33.33%',cursor:'pointer'}"> -->
        <!-- <div @click="headerImgClick" :style="{backgroundImage:'url(' + defaultHeaderImg + ')',minHeight: '300px',cursor:'pointer'}"> -->
        <!-- <div> -->
          <div v-cloak>
            <a :href="jumpUrl || '#'"  :target="jumpUrl? '_blank': ''">

              <img style="width:100%;" :src="headerImgUrl" alt="">


              <!-- <img style="width:100%;" v-if="headerImgUrl" :src="headerImgUrl" alt="imgUrl"> -->
              <!-- <img style="width:100%;" v-else :src="defaultHeaderImg" alt="avant"> -->



               <!-- <div v-if="headerImgUrl" :style="{backgroundImage:'url(' + headerImgUrl + ')','padding-bottom': '33.33%',cursor:'pointer'}">
              </div>
              <div v-else :style="{backgroundImage:'url(' + defaultHeaderImg + ')','padding-bottom': '33.33%',cursor:'pointer'}">
              </div> -->
            </a> 
          </div>
          <!-- <div v-else :style="{backgroundImage:'url(' + defaultHeaderImg + ')','padding-bottom': '33.33%',cursor:'pointer'}"> -->
          <!-- <div v-else>
            <img style="width:100%" v-if="headerImgUrl" :src="headerImgUrl" alt="imgUrl">
            <img style="width:100%" v-else :src="defaultHeaderImg" alt="avant">
          </div>       -->
        <!-- </div> -->
      </el-header>
      <el-container>
        <el-aside width="100%">
          <div class="article_right_position">
            <div class="article_right right">
              <div class="article_right_title">
                <span>活动介绍</span>
                <span class="article_right_title_two" @click="moreActivityIntroduceBtn">更多>></span>
              </div>
              <div class="rules description" v-html="rules"></div>
            </div>
          </div>
          <section class="voteDetail">
            <div class="left voteDetail_div">
              <p>{{allPlayerNum || 0}}人</p>
              <p>参选人数</p>
            </div>
            <div class="right voteDetail_div">
              <p>{{allVoteSum || 0}}次</p>
              <p>总投票数</p>
            </div>
          </section>
          <section class="voteCountdown">
            <span class="voteCountdown_span">活动倒计时</span>
            <div class="voteCountdown_time">
              <!-- <span><span :style="countDown(end_time).indexOf('0') <= 0? 'color: white': ''">{{countDown(end_time)[0] || 0}}</span><span :style="countDown(end_time).indexOf('0') <= 1? 'color: white': ''">{{countDown(end_time)[1] || 0}}</span>月</span> -->
              <span><span :style="countDown(end_time).indexOf('0') === 0? 'color: white': ''">{{countDown(end_time)[0] || 0}}</span><span :style="countDown(end_time)<1000000? 'color: white': ''">{{countDown(end_time)[1] || 0}}</span>天</span>
              <span><span :style="countDown(end_time)<100000? 'color: white': ''">{{countDown(end_time)[2] || 0}}</span><span :style="countDown(end_time)<10000? 'color: white': ''">{{countDown(end_time)[3] || 0}}</span>小时</span>
              <span><span :style="countDown(end_time)<1000? 'color: white': ''">{{countDown(end_time)[4] || 0}}</span><span :style="countDown(end_time)<100? 'color: white': ''">{{countDown(end_time)[5] || 0}}</span>分</span>
              <span><span :style="countDown(end_time)<10? 'color: white': ''">{{countDown(end_time)[6] || 0}}</span><span :style="countDown(end_time)<1? 'color: white': ''">{{countDown(end_time)[7] || 0}}</span>秒</span>
            </div>
          </section>
          <section class="voteTime">
            <div>
              <p>活动时间：<span>{{start_time || 0}}</span> — <span>{{end_time || 0}}</span></p>
            </div>
          </section>
          <section class="seachSection">
            <!-- <el-input clearable placeholder="请输入参选选手名字查询" v-model="seachValue" class="input-with-select">
              <el-button slot="append" @click="searchHandle">查询</el-button>
            </el-input> -->
            <input type="text" v-model="seachValue" placeholder="请输入参选选手名字查询">
            <el-button @click="searchHandle">查询</el-button>
          </section>
          <section>
            <div class="voteRank">
              <span @click='defaultRank' :class="voteRank===1? 'select': 'default'">默认排序</span>
              <span @click='rank' :class="voteRank===0? 'select': 'default'">排行榜</span>
            </div>
          </section>
          <article>
           
            <div class="article_left left">
              <div class="article_left__title">
                <span>评选人物</span>
                <div class="left"></div>
              </div>
              <div class="article_left__ul">
                <ul v-if='figureData.length>0' v-loading='tableLoading' element-loading-text="拼命加载中">
                  <li v-for='(item, index) in figureData' :key="index">
                    <div class="empty_top white"></div>
                    <div class="li_img" :style="{backgroundImage:'url(' + item.cover + ')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'contain'}">
                    <!-- <div class="li_img">
                      <img :src="item.cover" alt="img"/> -->
                    </div>
                    <div class="name-p"></div>
                    <p class="white ">编号{{item.code}}：{{item.name}}</p>
                    <div class="li_btn white" :data-id="item.id">
                      <el-button :data-id="item.id" v-loading.fullscreen.lock="voteLoading" @click="voteBtn($event)">投票</el-button>
                      <el-button :data-id="item.id" @click="detail($event)">详情</el-button>
                    </div>
                    <div class="empty"></div>
                    <div class="li_num">
                      <p>得票数：
                        <span>{{votes[item.id] || votes[index] || 0}}</span>
                        排行：
                        <span>
                          {{getRank(item.id) || (index+1) || 0}}
                        </span>
                      </p>
                    </div>
                  </li>
                </ul>
                <div v-else class="ifNoData">暂无数据</div>
              </div>
            </div>
            <el-dialog style="overflow-y: scroll" top='5vh' :fullscreen='dialogFullscreen' :width='dialogWidth' custom-class="dialogClass" :title="detailData.name + '详情'" centered :visible.sync="detailDialogVisible" >
              <!-- <div class="dialog-pic" :style="{backgroundImage:'url(' + detailData.cover + ')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'contain'}"> -->
              <div class="dialog-top-empty"></div>
              <div class="dialog-pic">
                <img :src="detailData.cover" alt="" style="position:relative; zoom:100%; cursor:move;" id="dialog_img">
              </div>
              <div class="center detailName">
                <span>{{detailData.name}}</span>
              </div>
              <p v-html="detailData.content" class="description"></p>
              <span slot="footer" class="dialog-footer" :data-id="detailData.id">
                <!-- <el-button @click="detailDialogVisible = false">取 消</el-button> -->

                <div class="footer-button">
                  <el-button type="primary" :data-id="detailData.id" plain @click="voteBtn($event)">投票</el-button>
                </div>
                
              </span>
            </el-dialog>
            <el-dialog title="活动介绍" style="overflow-y: scroll" top='5vh' :fullscreen='dialogFullscreen' :visible.sync="moreActivityIntroduce" width="60%">
              <div class="dialog-top-empty"></div>
              <p v-html="rules" class="description"></p>
              <span slot="footer" class="dialog-footer">
                <div class="footer-button">
                  <el-button @click="moreActivityIntroduce = false">确定</el-button>
                </div>
              </span>
            </el-dialog>
          </article>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import moment from 'moment';
import axios from "axios";
import $ from 'jquery';
// import defaultHeaderImg from "../assets/4c64652c8028d012708975f7acf196b5.jpg";
import defaultHeaderImg from "../assets/666ff66745ac64560afd814fbbc17d08.jpg";
export default {
  name: "Index",
  data() {
    return {
      figureData: [],
      votes: {},
      voteLoading: false,
      detailDialogVisible: false,
      moreActivityIntroduce: false,
      detailData: {},
      rules: null,
      id: null,
      headerImgUrl: null,
      defaultHeaderImg: defaultHeaderImg,
      vote_id: null,
      nowDate: null,
      jumpUrl: null,
      dialogWidth: '60%',
      dialogFullscreen: false,
      allPlayerNum: 0, // 投票总人数
      allVoteSum: 0, // 总投票数
      start_time: 0, // 投票起止时间
      now: moment(), // 现在时间
      end_time: '',
      seachValue: '',
      tableLoading: true,
      voteRank: 1,
      getTimeInt: null,
    };
  },
  methods: {
    detail: async function(e) {
      if (e) e.preventDefault();
      let id = null;
      id = e.target.parentNode.getAttribute("data-id");
      if (!id) {
        id = e.target.parentNode.parentNode.getAttribute("data-id");
      }
      if (id) {
        this.id = id;
        const resData = await axios.get(
          `/lua/api/vote/item?vote_id=${this.vote_id}&id=${id}`
        );
        this.detailData = resData.data.data.item;
        this.detailDialogVisible = true;




        // let activities = resData.data.data.item;
        // window.parameter = this.GetRequest(window.location.href);
        // let isWechat = (window.parameter.ways == 'wechat');//是否开启微信
        // let isAPP = (activities.publishing.app.is_open =='on');//是否开启APP
        // let isFollow = (window.parameter['following']!=1);//是否关注
        // let isCode = Boolean(activities.publishing.wechat.qr_code[0]);//是否上传二维码
        // let isPart = false;
        // if(isWechat){
        //     if(isFollow){
        //         isPart = true;
        //     }else{
        //         if(isCode){
        //             var qrCode = QRCode(activities.publishing.wechat.qr_code[0]).open();
        //         }else{
        //             isPart = true;
        //         }
        //     }
        // }else{
        //     //APP
        // }
        // if (typeof wxshare != 'undefined' && (activities.shares.isopen == 'on' || activities.shares.isopen == '1')) {
        //     var shareLink = '';
        //     if(isWechat){
        //         shareLink =window.location.origin+'/wechat/shares?id='+window.parameter.act_id;
        //     }else{
        //         shareLink = window.location.origin + location.pathname + '?from=singlemessage&act_id=' + wxshare.getUrlParam('act_id');
        //     }
        //     wxshare.share({
        //         title: activities.shares.title,
        //         desc: activities.shares.content,
        //         link: shareLink,
        //         imgUrl: activities.shares.thumb,
        //     });
        // }else{
        //     // forbidShare();
        // }












        // this.$nextTick(()=>{
        //   let dialog_img = document.getElementById("dialog_img");
        // })
        // this.imgToSize();
      }
    },
    /*
     * 获取?后面的参数并返回 json 对象
     */
     GetRequest(url) {
        if (!url || url.indexOf('?') == -1) {
            return {};
        }
        var url = url.split('?')[1].split('#')[0]; //获取url中"?"符后"#"前的字串
        var theRequest = new Object();
        var str = decodeURI(url);
        var strs;
        if (str.indexOf("&") != -1) {
            strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        } else {
            theRequest[str.split("=")[0]] = unescape(str.split("=")[1]);
        }
        theRequest['vote_id'] = theRequest['act_id'];

        return theRequest;
    },
    voteBtn: async function(e) {
      if (e) e.preventDefault();
      let _this = this;
      let id = null;
      id = e.target.parentNode.getAttribute("data-id");
      if (!id) {
        id = e.target.parentNode.parentNode.getAttribute("data-id");
      }
      if (id) {
        const loading = this.$loading({
          lock: true,
          text: "投票中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)"
        });
        let urlData = this.changeURLArg(location.href, "OpenID", this.nowDate);
        let newUrlData = this.changeURLArg(urlData, "uid", this.nowDate);
        const nowUrl = newUrlData
          .slice(newUrlData.indexOf("?"))
          .replace("#", "");
        const vote_token = await axios.get(`/api/app/sign/mf.php${nowUrl}`);
        const resData = await axios.get(
          `/lua/api/vote/vote${nowUrl}&item_id=${id}&vote_token=${
            vote_token.data.vote_token
          }&vote_id=${this.vote_id}`
        );
        if (resData.data.code === 200) {
          this.detailDialogVisible = false;
          setTimeout(() => {
            loading.close();
            this.$message({
              message: "投票成功",
              type: "success",
              duration: "1000"
            });
          }, 1500);
          if (this.voteRank === 1) {
            axios
            .get(`/lua/api/vote/details?&vote_id=${this.vote_id}&id=${id}`)
            .then(res => {
              this.allVoteSum = 0;
              this.allPlayerNum = res.data.data.details.items.length || 0;
              _this.figureData = [...res.data.data.details.items];
              _this.votes = { ...res.data.data.votes };
              for( let k in res.data.data.votes) {
                this.allVoteSum += res.data.data.votes[k];
              };
            });
          } else {
            axios.get(`/lua/api/vote/rank?vote_id=${this.vote_id}`).then(res => {
              this.allVoteSum = 0;
              this.figureData = [...res.data.items];
              this.votes = { ...res.data.scores };
              for( let k in res.data.scores) {
                this.allVoteSum += res.data.scores[k];
              };
            
            });
          }
          
        } else {
          loading.close();
          this.$message({
            message: resData.data.message,
            type: "error"
          });
        }
      }
    },
    changeURLArg: function(url, arg, arg_val) {
      var pattern = arg + "=([^&]*)";
      var replaceText = arg + "=" + arg_val;
      if (url.match(pattern)) {
        var tmp = "/(" + arg + "=)([^&]*)/gi";
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
      } else {
        if (url.match("[?]")) {
          return url + "&" + replaceText;
        } else {
          return url + "?" + replaceText;
        }
      }
      return url + "\n" + arg + "\n" + arg_val;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    moreActivityIntroduceBtn() {
      this.moreActivityIntroduce = true;
    },
    getQueryString: function(name) {
      var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      console.log(window.location);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    headerImgClick() {
      window.location.href = 'https://www.baidu.com/'
    },
    searchHandle() {
      console.log(this.seachValue);
      const _this = this;
      this.tableLoading = true;
      if (this.seachValue && this.seachValue.length > 0) {
         axios.get(`/api/vote/${_this.vote_id}/search?q=${_this.seachValue}`).then(res => {
          if (res && res.status === 200) {
            axios.post(`/lua/api/vote/search`, {
              act_id: _this.vote_id,
              ids: res.data.data['ids']
            }).then(response => {
              if (response.status === 200 && response.data.code === 200) {
                _this.figureData = [...response.data.data.items];
                _this.votes = { ...response.data.data.scores };
              } else {
                _this.figureData = [];
                _this.votes = {};
              } 
              this.tableLoading = false;
            })
          }
        });
      } else {
      this.voteRank = 1;
         axios
      .get(`/lua/api/vote/details?vote_id=${this.vote_id}`)
      .then(res => {
        if (res.status === 200) {
          this.figureData = [...res.data.data.details.items];
          this.votes = { ...res.data.data.votes };
          this.tableLoading = false;
        }
      })
      }
     
    },
    // imgToSize() {
    //   this.$nextTick(() => {
    //     let dialog_img = document.getElementById("dialog_img");
    //     if (dialog_img.style.zoom === "100%") {
    //       dialog_img.style.zoom = parseInt(dialog_img.style.zoom) + 100 + "%";
    //     }
    //   });
    // },
    defaultRank() {
      this.seachValue = '';
      this.voteRank = 1;
       axios.get(`/lua/api/vote/details?vote_id=${this.vote_id}`).then(res => {
        this.figureData = [...res.data.data.details.items];
        this.votes = { ...res.data.data.votes };

        const num = res.data.data.details.title.indexOf('||'); // 标题和跳转地址以||分割
        let title = res.data.data.details.title.slice(0, num || null);
        let activities = res.data.data.details;
        window.parameter = this.GetRequest(window.location.href);
        let isWechat = (window.parameter.ways == 'wechat');//是否开启微信
        let isAPP = (activities.publishing.app.is_open =='on');//是否开启APP
        let isFollow = (window.parameter['following']!=1);//是否关注
        let isCode = Boolean(activities.publishing.wechat.qr_code[0]);//是否上传二维码
        let isPart = false;
        if(isWechat){
            if(isFollow){
                isPart = true;
            }else{
                if(isCode){
                    var qrCode = QRCode(activities.publishing.wechat.qr_code[0]).open();
                }else{
                    isPart = true;
                }
            }
        }else{
            //APP
        }
        if (typeof wxshare != 'undefined' && (activities.shares.isopen == 'on' || activities.shares.isopen == '1')) {
            var shareLink = '';
            if(isWechat){
                shareLink =window.location.origin+'/wechat/shares?id='+window.parameter.act_id;
            }else{
                shareLink = window.location.origin + location.pathname + '?from=singlemessage&act_id=' + wxshare.getUrlParam('act_id');
            }
            wxshare.share({
                title: activities.shares.title || title,
                desc: activities.shares.content || '快来参加投票吧！',
                link: shareLink,
                imgUrl: activities.shares.thumb || 'http://wjtest-yanfa-cos-1257137142.cos.ap-beijing.myqcloud.com/tmp/20190729/19/20190729190357564182.png',
            });
        }else{
            // forbidShare();
        }





      });
    },
    rank() {
      this.seachValue = '';
      this.voteRank = 0;
       axios.get(`/lua/api/vote/rank?vote_id=${this.vote_id}`).then(res => {
        this.figureData = [...res.data.items];
        this.votes = { ...res.data.scores };
       
      });
    },
     //数字前补 0 
	  // num传入的数字，n需要的字符长度
    PrefixInteger(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
     getRank(key){
      if (!Array.isArray(this.votes)) {
        const arr = Object.keys(this.votes);
        for ( let k in arr) {
          if (arr[k] === key) {
            return (~~k + 1);
          }
        }
      }
    }
  },
  created() {
    
    if (document.body.clientWidth < 992) {
      this.dialogFullscreen = true;
    }
    this.vote_id = this.getQueryString("act_id");
    this.nowDate = Date.parse(new Date());
    axios
      .get(`/lua/api/vote/details?vote_id=${this.vote_id}`)
      // .get(`/lua/api/vote/rank?vote_id=${this.vote_id}`)
      .then(res => {
        if (res.status === 200) {
          this.allPlayerNum = res.data.data.details.items.length || 0;
          this.figureData = [...res.data.data.details.items];
          this.votes = { ...res.data.data.votes };
          this.rules = res.data.data.details.rules;
          this.headerImgUrl = res.data.data.details.background_img || this.defaultHeaderImg || 'http://wjtest-yanfa-cos-1257137142.cos.ap-beijing.myqcloud.com/20190618/10/20190618104830978310.jpg';
          const num = res.data.data.details.title.indexOf('||'); // 标题和跳转地址以||分割
          document.title = res.data.data.details.title.slice(0, num || null);
          this.jumpUrl = (num !== -1 ? res.data.data.details.title.slice(num+2) : null);
          for( let k in res.data.data.votes) {
            this.allVoteSum += res.data.data.votes[k];
          };
          // 起止时间
          this.end_time = res.data.data.details.end_time;
          this.start_time = res.data.data.details.start_time;
          this.tableLoading = false;
          // console.log(Object.keys(this.votes));


        let title = res.data.data.details.title.slice(0, num || null);
        let activities = res.data.data.details;
        window.parameter = this.GetRequest(window.location.href);
        let isWechat = (window.parameter.ways == 'wechat');//是否开启微信
        let isAPP = (activities.publishing.app.is_open =='on');//是否开启APP
        let isFollow = (window.parameter['following']!=1);//是否关注
        let isCode = Boolean(activities.publishing.wechat.qr_code[0]);//是否上传二维码
        let isPart = false;
        if(isWechat){
            if(isFollow){
                isPart = true;
            }else{
                if(isCode){
                    var qrCode = QRCode(activities.publishing.wechat.qr_code[0]).open();
                }else{
                    isPart = true;
                }
            }
        }
          var shareLink = '';
          if(isWechat){
              shareLink =window.location.origin+'/wechat/shares?id='+window.parameter.act_id;
          }else{
              shareLink = window.location.origin + location.pathname + '?from=singlemessage&act_id=' + wxshare.getUrlParam('act_id');
          }
          // console.log('¥', $);
          // console.log('title', window.location.href.slice(0, -1));
          wxshare.share({
              title: activities.shares.title || title,
              desc: activities.shares.content || '快来参加投票吧！',
              link: window.location.href.slice(0, window.location.href.indexOf('#/')),
              imgUrl: activities.shares.thumb || 'http://wjtest-yanfa-cos-1257137142.cos.ap-beijing.myqcloud.com/tmp/20190729/19/20190729190357564182.png',
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  mounted() {
    this.getTimeInt =  setInterval(()=>{
	   this.now = moment();
	 },1000)
  },
  computed: {
	  //计算属性，返回剩余时间
	  countDown(){
	    return function(endDate) {
	      let m1 = this.now;
	      let m2 = moment(endDate);
        let du = moment.duration(m2 - m1, 'ms');
        let years = du.get('years');
        let months = du.get('months');
        let days = du.get('day');
        let hours = du.get('hours');
        let mins = du.get('minutes');
        let ss = du.get('seconds');
        days +=  (months * 30 + years * 365);
        // console.log(days);
        if (days >= 99) {
          days = 99;
        };
	      if(days<=0&&hours<=0 && mins<=0 && ss<=0) {
	        return "00000000000000"
	      }else {
	        return this.PrefixInteger(days,2) + this.PrefixInteger(hours,2) + this.PrefixInteger(mins,2) + this.PrefixInteger(ss,2)
	      }
	    }
    },
   
	},
  beforeDestroy() {
    clearInterval(this.getTimeInt);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[v-cloak] {
  display: none !important;
}
@media (max-width: 1200px) {
  .root {
    width: 100%;
    margin: 0 auto;
    height: 80%;
    box-sizing: border-box;
  }
  .dialogClass {
    width: 90% !important;
    overflow-y: scroll;
  }
  header {
    max-height: 450px;
    /* background: red; */
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    padding: 0 !important;
  }
  .voteCountdown_time {
    height: 34px;
    /* line-height: 100px; */
    width: 360px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding-top: 32px;
    color: #8080805e;
    font-weight: 700;
  }
  .voteCountdown_time>span>span{
    background: #8080805e;
    margin-right: 6px;
    display: inline-block;
    width: 28px;
    height: 34px;
    /* line-height: 100px; */
    text-align: center;
    line-height: 34px;
    color: red;
    font-size: 22px;
    font-weight: 900;
  }
}
@media (min-width: 1200px) {
  .root {
    width: 75%;
    margin: 0 auto;
    height: 80%;
  }
  .dialogClass {
    width: 70% !important;
    overflow-y: scroll;
  }
  header {
    max-height: 800px;
    /* background: red; */
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    padding: 0 !important;
  }
  .voteCountdown_time {
    height: 34px;
    /* line-height: 100px; */
    width: 430px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding-top: 32px;
    color: #8080805e;
    font-weight: 700;
  }
  .voteCountdown_time > span:nth-of-type(n+1) {
    margin-left: 10px;
  }
  .voteCountdown_time>span>span{
    background: #8080805e;
    margin-right: 10px;
    display: inline-block;
    width: 28px;
    height: 34px;
    /* line-height: 100px; */
    text-align: center;
    line-height: 34px;
    color: red;
    font-size: 22px;
    font-weight: 900;
  }
}

.ifNoData {
  height: 500px;
  text-align: center;
  line-height: 500px;
   color: #8080805e;
   font-size: 30px;
   width: 100%;
}
.voteDetail {
  width: 95%;
  height: 100px;
  margin: 20px auto;
  /* background: bisque; */
  text-align: center;
}
.voteDetail_div {
  width: 49%;
  line-height: 30px;
  padding-top: 20px;
  background: #ffd8c4b5;
  height: 80%;
}
.voteDetail_div >p:nth-of-type(1) {
    font-weight: bolder;
    font-size: 28px;
    margin-bottom: 5px;
}
.voteCountdown {
  height: 100px;
  text-align: center;
  border: 2px solid red;
  position: relative;
}
.voteCountdown_span {
  position: absolute;
  top: -18px;
  left: calc(50% - 65px);
  font-size: 24px;
  color: red;
  font-weight: 900;
  display: inline-block;
  width: 130px;
  background: white;
  z-index: 999;
  text-align: center;
}
.seachSection {
  font-size: 0;
  display: flex;
}
.seachSection >input:focus {
  outline: none;
}
.seachSection >input {
  vertical-align: top;
  outline: none;
  /* width: 90%; */
  height: 40px;
  font-size: 14px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 15px;
  box-sizing: border-box;

  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 0 10px;
  display: block;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}
.seachSection >button {
  width: 60px;
  height: 40px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-left: none;
}

.voteTime {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-weight: 500;
}
.voteRank {
  height: 50px;
  margin-top: 30px;
  text-align: center;
  color: white;
}
.voteRank > span:nth-of-type(1) {
  margin-right: 20px;
}
.voteRank > .select {
  display: inline-block;
  padding: 5px 20px;
  border-radius: 40px;
  background: red;
  cursor: pointer;
  font-weight: bolder;
  font-size: 22px;
}
.voteRank > .default {
  /* display: inline-block;
  padding: 5px 20px;
  border-radius: 40px;
  background: red; */
  cursor: pointer;
  font-weight: bolder;
  font-size: 22px;
  color: black;
}
.input-with-select .el-input-group__prepend .el-button {
    color: black!important;
  }


.dialogClass {
    width: 70% !important;
    overflow-y: scroll;
  }
* {
  margin: 0;
  padding: 0;
}
.footer-button {
  text-align: center;
}
.footer-button button {
  color: white;
  width: 70px;
  height: 40px;
  background: #409eff;
}
.center {
  text-align: center;
}
.ql-toolbar.ql-snow {
  display: none;
}
.left {
  float: left;
}
.right {
  float: right;
}
.dialog-top-empty {
  width: 100%;
  height: 1px;
  background: #8f8a8a5e;
  margin: -20px 0 20px 0;
}

article {
  border: 1px solid rgba(70, 111, 18, 0.17);
  /* height: 500px; */
  width: 100%;
  margin: 10px auto;
  overflow: hidden;
  padding: 10px 20px;
  box-sizing: border-box;
  /* background: green; */
}
.article_left {
  width: 100%;
}
.article_left__title {
  height: 30px;
  width: 100%;
  line-height: 30px;
  background: rgb(234, 234, 234);
}
.article_left__title span {
  /* display: inline-block; */
  height: 100%;
  padding: 0 20px;
  background: red;
  color: white;
  float: left;
}
.article_left__title div {
  height: 30px;
  width: 30px;
  border-width: 15px;
  border-style: solid;
  box-sizing: border-box;
  border-color: transparent transparent transparent red;
}
.article_left__ul {
  margin: 0;
  padding: 0;
  overflow: hidden;
  width: 100%;
}
@media (max-width: 1200px) {
  .article_left__ul li {
    width: 49%;
    margin-right: 1%;
    /* height: 380px; */
    border: 1px solid rgba(70, 111, 18, 0.17);
    float: left;
    box-sizing: border-box;
    list-style: none;
    margin-top: 1%;
    margin-bottom: 2%;
    text-align: center;
    background-color: #f2f2f2;
  }
}
@media (max-width: 320px) {
  .article_left__ul li {
    width: 95%;
    margin-right: 1%;
    /* height: 380px; */
    border: 1px solid rgba(70, 111, 18, 0.17);
    float: left;
    box-sizing: border-box;
    list-style: none;
    margin-top: 1%;
    margin-bottom: 2%;
    text-align: center;
    background-color: #f2f2f2;
  }
}
@media (min-width: 1200px) {
  .article_left__ul li {
    width: 19%;
    margin-right: 1%;
    /* height: 380px; */
    border: 1px solid rgba(70, 111, 18, 0.17);
    float: left;
    box-sizing: border-box;
    list-style: none;
    margin-top: 1%;
    margin-bottom: 2%;
    text-align: center;
    background-color: #f2f2f2;
  }
}

/* .article_left__ul li {
  width: 19%;
  margin-right: 1%;
  border: 1px solid rgba(70, 111, 18, 0.17);
  float: left;
  box-sizing: border-box;
  list-style: none;
  margin-top: 1%;
  margin-bottom: 2%;
  text-align: center;
  background-color: #f2f2f2;
} */
.li_img {
  width: 100%;
  padding-bottom: 116.666%;
  /* height: 70%; */
  margin: 0 auto;
  /* padding: 5px; */
  background-color: white;
  box-sizing: border-box;
}
.dialog-button {
  font-size: 14px;
  padding: 4px 8px;
  border: 1px solid #8daab5;
  border-radius: 6px;
  background-color: white;
}
.dialog-pic {
  width: 100%;
  /* height: 150px; */
  /* max-height: 300px; */
  /* background: chartreuse; */
  margin: 5px auto;
  text-align: center;
}
.dialog-pic img {
  max-width: 100%;
  /* max-height: 300px; */
}
.detailName {
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 20px;
  margin-top: 10px;
  color: black;
}
.empty_top {
  width: 100%;
  /* height: 5px; */
  background-color: white;
}
.white {
  background-color: white;
}
.article_left__ul li p {
  font-size: 14px;
}
.article_left__ul li img {
  width: 100%;
  height: 100%;
}
.li_num {
  background-color: #f2f2f2;
  margin: 5px 0;
}
article button {
  font-size: 14px;
  padding: 4px 8px;
  border: 1px solid #8daab5;
  border-radius: 6px;
  background-color: #f2f2f2;
  color: #000000d4;
  font-weight: 400;
}

.li_btn {
  padding: 20px 0 10px;
}
.li_num span {
  color: red;
}
ul {
  overflow: hidden;
  min-height: 500px;
  /* background: gold; */
  margin-top: 10px;
}

.article_right {
  /* margin: 10px auto; */
  width: 100%;
  height: 300px;
  box-sizing: border-box;
  /* overflow: hidden; */
  /* background: green; */
  border: 1px solid rgba(70, 111, 18, 0.17);
  overflow-y: scroll;
  padding-top: 30px;
}
.article_right_position {
  box-sizing: border-box;
  /* padding: 0px 20px; */
  position: relative;
  width: 100%;
  height: 300px;
  margin: 10px auto;
  border: 1px solid rgba(70, 111, 18, 0.17);
}
.article_right_title {
  padding: 0 20px;
  position: absolute;
  top: 0;
  left: 0;
  height: 30px;
  width: 100%;
  line-height: 30px;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  color: white;
}
.name-p {
  width: 100%;
  height: 5px;
  background: white;
}
.el-dialog__header {
  padding: 0;
}
.dialog-footer {
  text-align: center;
}
.article_right_title_two {
  cursor: pointer;
}
.empty {
  width: 80%;
  height: 1px;
  background-color: rgba(17, 11, 59, 0.22);
  margin: 0 auto;
}
.rules {
  font-size: 14px;
  padding: 10px;
}
.description {
  font-size: 16px;
  line-height: 30px;
  color: black;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue